import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import setView from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetView";
import { getProductListDataView } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import { ProductListViewType } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { disabledByType } from "@insite/mobius/FormField/formStyles";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Filter from "@insite/mobius/Icons/Filter";
import Search from "@insite/mobius/Icons/Search";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Page from "@insite/mobius/Page";
import { Disabled } from "@insite/mobius/Swatch";
import { breakpointMediaQueries, injectCss } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import filterView from "@tecumseh/MobiusOverrides/Icons/filterView";
import gridView from "@tecumseh/MobiusOverrides/Icons/gridView";
import listView from "@tecumseh/MobiusOverrides/Icons/listView";
import ProductListSearchWithin from "@tecumseh/Overrides/Widgets/ProductList/ProductListSearchWithin";
import { COLORS } from "@tecumseh/theme/design";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

interface State {
    createListModalIsOpen: boolean;
}
interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    const correctedQuery = getProductListDataViewProperty(state, "correctedQuery");
    const { productFilters } = state.pages.productList;

    return {
        loaded: !!getProductListDataView(state).value,
        view: state.pages.productList.view,
        query: correctedQuery || productFilters.query,
        location: getLocation(state),
    };
};

const mapDispatchToProps = {
    setView,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface ProductListViewSelectStyles {
    wrapper?: InjectableCss;
    listViewClickable?: ClickablePresentationProps;
    listViewIcon?: IconPresentationProps;
    listViewDisabledIcon?: IconPresentationProps;
    gridViewClickable?: ClickablePresentationProps;
    gridViewIcon?: IconPresentationProps;
    gridViewDisabledIcon?: IconPresentationProps;
    tableViewClickable?: ClickablePresentationProps;
    tableViewIcon?: IconPresentationProps;
    FilterViewIcon?: IconPresentationProps;
    createListButton?: ButtonPresentationProps;
    createListModal?: ModalPresentationProps;
}

export const viewSelectStyles: ProductListViewSelectStyles = {
    wrapper: {
        css: css`
            display: flex;
            padding-top: 5px;
            float: right;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex: 1;
                        justify-content: flex-end;
                    `,
                    css`
                        flex: 1;
                        justify-content: flex-end;
                    `,
                    css`
                        flex: 1;
                        justify-content: flex-end;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    listViewClickable: {
        css: css`
            margin-right: 10px;
        `,
    },
    gridViewClickable: {
        css: css`
            margin-right: 10px;
        `,
    },
    listViewIcon: {
        src: listView,
        size: 16,
        css: css`
            svg {
                color: ${getColor("secondary")};
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        /* display: none; */
                    `,
                    css`
                        /* display: none; */
                    `,
                    null,
                    null,
                ])}
        `,
    },
    listViewDisabledIcon: {
        src: listView,
        size: 16,
        css: css`
            svg {
                g {
                    fill: ${COLORS.graySwan};
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        /* display: none; */
                    `,
                    css`
                        /* display: none; */
                    `,
                    null,
                    null,
                ])}
        `,
    },
    gridViewIcon: {
        src: gridView,
        size: 16,
        css: css`
            svg {
                color: ${getColor("secondary")};
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        /* display: none; */
                    `,
                    css`
                        /* display: none; */
                    `,
                    null,
                    null,
                ])}
        `,
    },
    gridViewDisabledIcon: {
        src: gridView,
        size: 16,
        css: css`
            svg {
                g {
                    fill: ${COLORS.graySwan};
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        /* display: none; */
                    `,
                    css`
                        /* display: none; */
                    `,
                    null,
                    null,
                ])}
        `,
    },
    FilterViewIcon: {
        src: Filter,
        size: 14,
        css: css`
            display: none;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: block;
                        border-radius: 5px;
                        opacity: 1;
                        background-color: rgba(238, 238, 238, 1);
                        height: 29.5px;
                        width: 29px;
                        margin-right: -18px;
                        > svg {
                            transform: translate(50%, 40%);
                        }
                    `,
                    css`
                        display: block;
                        border-radius: 5px;
                        opacity: 1;
                        background-color: rgba(238, 238, 238, 1);
                        height: 29.5px;
                        width: 29px;
                        > svg {
                            transform: translate(50%, 40%);
                        }
                    `,
                    css`
                        display: block;
                        border-radius: 5px;
                        opacity: 1;
                        background-color: rgba(238, 238, 238, 1);
                        height: 29.5px;
                        width: 29px;
                        margin-right: 10px;
                        > svg {
                            transform: translate(50%, 40%);
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
    createListModal: {
        cssOverrides: {
            modalBody: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            opacity: 1;
                            background-color: rgba(245, 246, 247, 1);
                            margin-top: 130px !important;
                            margin-left: 10px !important;
                            margin-right: 10px !important;
                        `,
                        css`
                            opacity: 1;
                            background-color: rgba(245, 246, 247, 1);
                            margin-top: 130px !important;
                            margin-left: 10px !important;
                            margin-right: 10px !important;
                        `,
                        css`
                            opacity: 1;
                            background-color: rgba(245, 246, 247, 1);
                            margin-top: 130px !important;
                            margin-left: 10px !important;
                            margin-right: 10px !important;
                        `,
                        null,
                        null,
                    ])}
            `,
            modalTitle: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 11px 8px;
                            border-bottom: none;
                        `,
                        css`
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 11px 8px;
                            border-bottom: none;
                        `,
                        css`
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 11px 8px;
                            border-bottom: none;
                        `,
                        null,
                        null,
                    ])}
            `,
            modalContent: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 10px;
                            overflow-y: visible;
                            margin-top: -37px;
                            padding-bottom: 100px !important;
                        `,
                        css`
                            padding: 10px !important;
                            overflow-y: visible;
                            margin-top: -37px;
                            padding-bottom: 100px !important;
                        `,
                        css`
                            padding: 10px !important;
                            overflow-y: visible;
                            margin-top: -37px;
                            padding-bottom: 100px !important;
                        `,
                        null,
                        null,
                    ])}
            `,
            titleButton: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 4px;
                            border-radius: 5px !important;
                            height: 30px !important;

                            span {
                                color: rgba(0, 110, 210, 1) !important;
                                opacity: 1;
                            }
                        `,
                        css`
                            padding: 4px;
                            border-radius: 5px !important;
                            height: 30px !important;

                            span {
                                color: rgba(0, 110, 210, 1) !important;
                                opacity: 1;
                            }
                        `,
                        css`
                            padding: 4px;
                            border-radius: 5px !important;
                            height: 30px !important;

                            span {
                                color: rgba(0, 110, 210, 1) !important;
                                opacity: 1;
                            }
                        `,
                        null,
                        null,
                    ])}
            `,
        },
    },

    // tableViewIcon: {
    //     src: Table,
    //     size: 16,
    // },
};

const styles = viewSelectStyles;

class ProductListViewSelect extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            // gridViewStyle: {},
            createListModalIsOpen: false,
        };
    }

    buttonClickHandler = () => {
        this.setState({ createListModalIsOpen: true });
    };
    modalCloseHandler = () => {
        this.setState({ createListModalIsOpen: false });
    };

    UNSAFE_componentWillMount() {
        const view = getCookie("ProductList-View");
        if (view && this.props.view !== view) {
            this.props.setView({ view: view as ProductListViewType });
        }
    }
    render() {
        const { loaded, view, setView, query, location } = this.props;

        const locationPath = location.pathname.includes("/Search");

        if (!loaded) {
            return null;
        }
        // const clickListViewHandler = () => {
        //     changeView("List");
        // };

        const clickGridViewHandler = () => {
            changeView("Grid");
        };

        const clickTableViewHandler = () => {
            changeView("Table");
        };

        const changeView = (view: ProductListViewType) => {
            setCookie("ProductList-View", view);
            setView({ view });
        };

        return (
            <StyledWrapper {...styles.wrapper}>
                <Clickable data-test-selector="productListFilterList" onClick={this.buttonClickHandler}>
                    <VisuallyHidden>{translate("filters")}</VisuallyHidden>
                    <Icon {...styles.FilterViewIcon} />
                </Clickable>
                <Modal
                    {...styles.createListModal}
                    isOpen={this.state.createListModalIsOpen}
                    handleClose={this.modalCloseHandler}
                >
                    <Zone contentId={this.props.id} zoneName="Content" requireRows />
                </Modal>

                <Clickable
                    data-test-selector="viewSelectGrid"
                    {...styles.gridViewClickable}
                    onClick={clickGridViewHandler}
                >
                    <VisuallyHidden>{translate("Product Grid View")}</VisuallyHidden>

                    <Icon
                        {...(view === "Grid" ? { ...styles.gridViewIcon } : { ...styles.gridViewDisabledIcon })}
                        color={view === "Grid" ? "primary" : "text.disabled"}
                    />
                </Clickable>
                {/* <Clickable
                    data-test-selector="viewSelectList"
                    {...styles.listViewClickable}
                    onClick={clickListViewHandler}
                >
                    <VisuallyHidden>{translate("Product List View")}</VisuallyHidden>
                    <Icon
                        {...(view === "List" ? { ...styles.listViewIcon } : { ...styles.listViewDisabledIcon })}
                        color={view === "List" ? "primary" : "text.disabled"}
                    />
                </Clickable> */}

                <Clickable
                    data-test-selector="viewSelectTable"
                    {...styles.gridViewClickable}
                    onClick={clickTableViewHandler}
                >
                    <VisuallyHidden>{translate("Product Table View")}</VisuallyHidden>

                    <Icon
                        {...(view === "Table" ? { ...styles.listViewIcon } : { ...styles.listViewDisabledIcon })}
                        color={view === "List" ? "primary" : "text.disabled"}
                    />
                </Clickable>
            </StyledWrapper>
        );
    }
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListViewSelect),
    definition: {
        group: "Product List",
        displayName: "View Select",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
